import { c as _c } from "react/compiler-runtime";
import { Accordion } from '@systemeio/components';
import { ChevronDownFilledIcon } from '@systemeio/icons';
import { ReactNode } from 'react';
const DISCLOSURE_ITEM_VALUE = 'content';
export interface DisclosureBoxProps {
  actions?: ReactNode;
  children?: ReactNode;
  defaultOpen?: boolean;
  description?: ReactNode;
  disabled?: boolean;
  invalid?: boolean;
  label: ReactNode;
}
export function DisclosureBox(t0) {
  const $ = _c(26);
  const {
    actions,
    children,
    defaultOpen,
    description,
    disabled,
    invalid,
    label
  } = t0;
  let t1;
  if ($[0] !== defaultOpen) {
    t1 = defaultOpen ? [DISCLOSURE_ITEM_VALUE] : undefined;
    $[0] = defaultOpen;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = invalid ? "border-border-error" : undefined;
  const t3 = invalid || undefined;
  let t4;
  if ($[2] !== label) {
    t4 = <span className="min-w-0 flex-1 truncate">{label}</span>;
    $[2] = label;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== description) {
    t5 = description !== undefined && <span className="text-text-link shrink-0">{description}</span>;
    $[4] = description;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <ChevronDownFilledIcon aria-hidden={true} className="text-icon-primary transition-base size-5 shrink-0 group-data-panel-open:rotate-180" />;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== disabled || $[8] !== t3 || $[9] !== t4 || $[10] !== t5) {
    t7 = <Accordion.Header className="min-w-0 flex-1"><Accordion.Trigger aria-invalid={t3} className="group" disabled={disabled}>{t4}{t5}{t6}</Accordion.Trigger></Accordion.Header>;
    $[7] = disabled;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== actions) {
    t8 = actions !== undefined && <div className="shrink-0 pr-5">{actions}</div>;
    $[12] = actions;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t7 || $[15] !== t8) {
    t9 = <div className="flex items-center">{t7}{t8}</div>;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== children) {
    t10 = <Accordion.Panel><Accordion.Content>{children}</Accordion.Content></Accordion.Panel>;
    $[17] = children;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t2 || $[21] !== t9) {
    t11 = <Accordion.Item className={t2} value={DISCLOSURE_ITEM_VALUE}>{t9}{t10}</Accordion.Item>;
    $[19] = t10;
    $[20] = t2;
    $[21] = t9;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t1 || $[24] !== t11) {
    t12 = <Accordion.Root defaultValue={t1}>{t11}</Accordion.Root>;
    $[23] = t1;
    $[24] = t11;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  return t12;
}